import { render, staticRenderFns } from "./LhAi.vue?vue&type=template&id=0ffa2b82&scoped=true"
import script from "./LhAi.vue?vue&type=script&lang=js"
export * from "./LhAi.vue?vue&type=script&lang=js"
import style0 from "./LhAi.vue?vue&type=style&index=0&id=0ffa2b82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffa2b82",
  null
  
)

export default component.exports